// Shared initials-avatar helpers, used wherever a person is shown without a photo. One neutral colour for everyone: a colour
// per person carried no meaning and competed with the status colours.
const AVATAR_CLASS = "bg-slate-100 text-slate-700";

export function getInitials(name, email) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length > 1) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  return (parts[0] || email || "?").slice(0, 2).toUpperCase();
}

export function avatarColorClass() {
  return AVATAR_CLASS;
}
